export default __webpack_public_path__ + "static/media/msgok.8da5046a.png";